export const PM_STATUS = {
  pending: "PENDING",
  confirmed_by_internal: "CONFIRMED_BY_INTERNAL",
  confirmed_by_client: "CONFIRMED_BY_CLIENT",
  approved_by_internal: "APPROVED_BY_INTERNAL",
  rejected_by_internal: "REJECTED_BY_INTERNAL",
  canceled_by_client: "CANCELED_BY_CLIENT",
};

export const PM_ACTIONS = {
  confirm: "CONFIRM",
  reject: "REJECT",
  approve: "APPROVE",
  cancel: "CANCEL",
  editnav: "EDITNAV",
};

export const PmInvestmentOrderStatusRev = {
  INTENDED: 'INTENDED',
  BINDING: 'BINDING',
  COMMITTED: 'COMMITTED',
  CANCELED: 'CANCELED',
  ON_SELL: 'REQUESTED_SELL'
};

/* The colours that used to live here are gone: seventeen constants — a teal,
   two ambers, three separate reds (#FF4d4f, #EF1E1E and the keyword red), a
   crayola blue, a mint, a cadet grey, a chart palette and a section
   background — with, by the end, not one consumer between them. Seven were
   orphaned when the status chip became the shared one; the rest had already
   been dead. A file of colours nobody reads is where the next off-palette
   colour comes from, so it is not kept as a convenience.

   Colours come from `src/theme/colors` and `src/theme/ui`. A status tone is
   the shared Badge's, in ./PrivateEquityActionsStatusRender. */

export const INTENDED = "INTENDED";
export const BINDING = "BINDING";
export const COMMITTED = "COMMITTED";
export const CANCELED = "CANCELED";


export const PENDING = "PENDING";
export const REJECTED = "REJECTED";
export const CONFIRMED = "CONFIRMED";
